<template>
  <div
    class="vcore_input-group"
    :class="{ 'vcore_has-error': !!error, 'feedback-padding': !error }"
  >
    <label
      v-if="label"
      class="vcore_input-label"
      :class="{ 'vcore_input-label_optional': !required }"
      :style="{ color: labelColor }"
      :for="id | idFormat"
      :id="ariaLabelledBy | ariaFormat"
      >
      {{ label }}
    </label>
    <button v-if="popover" :ref="`${id}_label-icon` | idFormat" class="popover-trigger"
      aria-label="More info" type="button">
      <i class="vcore_icon icon-info"></i>
    </button>
    <Popover v-if="popover && popoverTarget"
             :placement="popover.placement"
             :target="popoverTarget"
             :title="popover.title"
             :content="popover.content"
             :id="popover.id"
    ></Popover>
    <input
      type="text"
      v-model="bindVal"
      @blur="handleBlur"
      @focusin="handleFocus"
      class="vcore_input"
      autocomplete="nope"
      :placeholder="placeholder"
      :class="{ 'vcore_input--error': !!error, [size]: !!size }"
      :name="name || label"
      :aria-labelledby="ariaLabelledBy | ariaFormat"
      :aria-invalid="`${!!error}`"
      :aria-required="`${required}`"
      :aria-errormessage="ariaErrorMessage"
      :id="id | idFormat"
    />
    <span class="vcore_input-addon"> </span>
    <div
      class="vcore_input-feedback feedback-position"
      :id="errorId | idFormat"
      v-if="error"
      aria-live="assertive"
    >{{ error }}</div>
  </div>
</template>

<script>
import Popover from "./Popover";

export default {
  name: "Ssn",
  props: {
    label: String,
    name: String,
    value: {},
    placeholder: String,
    labelStyle: String,
    inputStyle: String,
    size: {
      default: ""
    },
    labelColor: String,
    required: Boolean,
    error: String,
    formName: String,
    popover: Object
  },
  components: {
    Popover
  },
  data() {
    return {
      content: this.value,
      popoverTarget: null,
      hasFocus: false
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.content = this.formatVal(newVal);
        }
      },
      immediate: true
    },
    content: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.content = this.formatVal(newVal);

          this.$emit('input', newVal.replace(/\D/g, ''));
        }
      },
      immediate: true
    }
  },
  computed: {
    id() {
      if (this.formName) {
        return `${this.formName}_${this.label}`;
      }
      return this.label;
    },

    ariaLabelledBy() {
      return `${this.id}--label`;
    },

    ariaErrorMessage() {
      return this.error ? this.$options.filters.idFormat(this.errorId) : undefined;
    },

    errorId() {
      return `${this.id}--error`;
    },

    bindVal: {
      get() {
        if (this.hasFocus) {
          return this.content
        }

        // return this.$options.filters.ssn(this.content).substring(0, this.content.length);
        return this.$options.filters.ssn(this.content);
      },

      set(val) {
        if (this.hasFocus) {
          this.content = val;
        }
      }
    }
  },
  methods: {
    formatVal(val) {
      let formatted = val.replace(/\D/g,'').substring(0, 9);

      if (formatted.length > 3) {
        formatted = formatted.substring(0, 3) + "-" + formatted.substring(3);
      }

      if (formatted.length > 6) {
        formatted = formatted.substring(0, 6) + "-" + formatted.substring(6);
      }

      if (formatted.length > 11) {
        formatted = formatted.substring(0, 11);
      }

      return formatted;
    },
    handleFocus() {
      this.hasFocus = true;
    },
    handleBlur() {
      this.hasFocus = false;
      this.$emit('blur');
    }
  },
  mounted() {
    this.popoverTarget = this.$refs[`${this.$options.filters.idFormat(this.id)}_label-icon`];
  }
};
</script>

<style lang="scss" scoped>
input.vcore_input {
  &.small {
    height: 30px;
  }

  &.large {
    height: 50px;
  }
}

.vcore_input-group {

  .vcore_input-label + button.popover-trigger {
    display: inline-block;
    color: $color_dark-blue;
    cursor: pointer;
    margin-left: 4px;

    .vcore_icon {
      font-size: 16px;
    }
  }
}

.feedback-position {
  position: absolute;
}

.popover-trigger {
  border-radius: 500px;
  border: none;
  background: none;
  width: fit-content;
  height: fit-content;
  padding: 0;
  margin-left: 4px;
}

.popover-trigger:focus-visible {
  outline: 2px solid black;
  outline-offset: 2px;
}
</style>
